<template>
    <div class="main-page">
        <homePromo></homePromo>
        <homeNews></homeNews>
        <homeConstruction></homeConstruction>
        <homeAbout></homeAbout>
        <homeVacancy></homeVacancy>
        <homeProjects></homeProjects>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import homePromo from '@/components/home-page/home-promo.vue'
    import homeNews from '@/components/home-page/home-news.vue'
    import homeConstruction from '@/components/home-page/home-construction.vue'
    import homeAbout from '@/components/home-page/home-about.vue'
    import homeVacancy from '@/components/home-page/home-vacancy.vue'
    import homeProjects from '@/components/home-page/home-projects.vue'
    import store from '@/store.js'
    export default {
        name: 'main--page',
        components: {
            homePromo,
            homeNews,
            homeConstruction,
            homeAbout,
            homeVacancy,
            homeProjects,
        },
        data () {
            return {
                // titlePage: 'Главная',
            }
        },
        computed: mapGetters({
           pageSetup: 'loadIndexPage',
        }),
        methods: {
            // setLocale(lang) {
            //     localStorage.setItem('language', lang);
            //     document.location.reload(true);
            // }
        },
        beforeRouteEnter (to, from, next) {
            // store.dispatch('getIndexPageData');
            if (store.state.indexPage != null) {
                next(vm => {
                  vm.$store.commit('removePageLoaderImg');
                  vm.$parent.$refs.topProgress.done()
                });
            } else {
                store.dispatch('getIndexPageData').then((response) => {
                    // console.log(resp, 'HOME')
                    if (response) {
                        next(vm => {
                          vm.$store.commit('removePageLoaderImg');
                          vm.$parent.$refs.topProgress.done()
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
            store.dispatch('getNewsItems');
        },
        beforeCreate() {
            document.body.dataset.page = 'home';
        },
        created () {
            // document.title = this.titleSite;
        },
        mounted() {
            // console.log('render')
            // this.$parent.$refs.topProgress.start();
        }
    }
</script>
